import React, { useState } from "react"
import { CSSTransition } from "react-transition-group"

import styles from "./index.module.css"

type Props = {
  className?: string
}

export const Accordion: React.FC<Props> = ({ className, children }) => {
  const [selectedPanel, setSelectedPanel] = useState("")

  const childrenProps = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) {
      return child
    }
    return child.props
  }) as any[]

  const onPanelSelect = (question: string) => () => {
    setSelectedPanel(selectedPanel === question ? "" : question)
  }

  const answerToggle = (e: HTMLElement, question: string): void => {
    const answerWrapper = e.parentElement as HTMLElement
    const selfHeight = e.scrollHeight.toString()

    answerWrapper.style.height = `${selectedPanel === question ? selfHeight : "0"}px`
  }

  return (
    <div className={className}>
      {childrenProps.map(({ question, children }) => (
        <div key={question} className={styles.Block}>
          <div
            dangerouslySetInnerHTML={{ __html: question }}
            className={styles.Question}
            data-state={selectedPanel === question ? "open" : undefined}
            onClick={onPanelSelect(question)}
          />

          <div className={styles.AnswerWrapper}>
            <CSSTransition
              classNames={{
                enter: styles.FadeEnter,
                enterActive: styles.FadeEnterActive,
                exitActive: styles.FadeExitActive,
                exitDone: styles.FadeExitActive,
              }}
              in={selectedPanel === question}
              timeout={300}
              unmountOnExit
              onEnter={(e) => answerToggle(e, question)}
              onExit={(e) => answerToggle(e, question)}
            >
              <div className={styles.Answer}>{children}</div>
            </CSSTransition>
          </div>
        </div>
      ))}
    </div>
  )
}

export const Panel: React.FC<{ question: string; id?: string }> = ({ children }) => {
  return <>{children}</>
}
